<template>
  <div class="product-detail-section">
    <div class="container">
      <!-- 返回按钮 -->
      <div class="back-button" @click="goBack">
        ← 
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="loading">
        <p>加载中...</p>
      </div>

      <!-- 商品详情内容 -->
      <div v-else-if="product" class="product-detail-content">
        <!-- 左侧图片 -->
        <div class="product-detail-image">
          <img :src="product.shopAvatar" :alt="product.displayName" width="600px" height="300px" />
        </div>

        <!-- 右侧商品信息 -->
        <div class="product-detail-info">
          <h1 class="product-detail-title">{{ product.displayName }}</h1>
          
          <div class="product-detail-price">
            <!-- <span class="price-range">{{ $t('store.currency') }}{{ product.displayPrice }}</span> -->
          </div>

          <div class="product-detail-description">
       
              {{ product.displayContent }}
          </div>


        </div>
      </div>

      <!-- 商品不存在时的提示 -->
      <div v-else class="product-not-found">
        <h2>商品不存在</h2>
        <p>抱歉，您查找的商品不存在或已下架。</p>
        <button class="btn btn-primary" @click="goBack">返回商品列表</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductDetail } from '../api/product'
import { processProductData } from '../utils/i18nData'

export default {
  name: 'ProductDetail',
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      selectedSize: '',
      selectedQuantityOption: '',
      quantity: 1,
      rawProduct: null,
      loading: true
    }
  },
  computed: {
    // 当前语言
    currentLocale() {
      return this.$i18n.locale
    },
    // 处理后的产品数据（根据当前语言）
    product() {
      return processProductData(this.rawProduct, this.currentLocale)
    }
  },
  async mounted() {
    await this.loadProduct();
  },
  methods: {
    // 加载产品详情
    async loadProduct() {
      try {
        this.loading = true;
        const response = await getProductDetail(this.id);
        console.log('产品详情数据:', response.data);
        // 根据实际返回的数据结构调整
        this.rawProduct = response.data.data || null;
      } catch (error) {
        console.error('加载产品详情失败:', error);
        // 如果接口调用失败，使用默认数据
        const defaultProducts = [
          {
            id: 1,
            name: '一次性床品四件套',
            description: '纯天然野生蜂蜜，营养丰富',
            price: '168',
            priceRange: '¥34.99 - ¥179.00',
            image: require('../assets/1.png'),
            detailImage: 'https://picsum.photos/600/600?random=1',
            sizes: ['单人床 90x200cm', '双人床 150x200cm', '大床 180x200cm', '特大床 200x220cm'],
            quantityOptions: ['1套', '2套', '3套', '5套', '10套'],
            detailDescription: [
              '自然无忧一次性床品四件套让您的睡眠更加舒心、惬意。',
              '我们使用一等一的水刺无纺布，生产出了符合标准的四件套。',
              '它适合各种场合：出差，也适合家庭旅行，火车的铺位，轻松解决问题。酒店住宿，简直就是so easy的！',
              '出海游艇的首选更离不开我们的陪伴！',
              '这个行走的睡眠保护层，把您保护得妥妥当当，便携袋立包装，让您拿起就就走。',
              '它韧性强又耐撞打，细腻不起毛，远离病菌的交叉感染。',
              '被时刻呵护的您，难道不觉得睡眠质量在于升级么？'
            ]
          },
          {
            id: 2,
            name: '有机茶叶',
            description: '高山有机茶叶，清香回甘',
            price: '288',
            priceRange: '¥188.99 - ¥388.00',
            image: require('../assets/特点1.png'),
            detailImage: 'https://picsum.photos/600/600?random=2',
            sizes: ['单人床 90x200cm', '双人床 150x200cm', '大床 180x200cm'],
            quantityOptions: ['1套', '2套', '3套', '5套'],
            detailDescription: [
              '高品质有机茶叶，采用传统工艺制作。',
              '精选高山茶园原料，保证茶叶的纯正品质。',
              '无农药残留，天然健康的选择。',
              '口感清香回甘，适合日常饮用。'
            ]
          },
          {
            id: 3,
            name: '草本精华',
            description: '天然草本提取，温和养护',
            price: '398',
            priceRange: '¥298.99 - ¥498.00',
            image: require('../assets/特点2.png'),
            detailImage: 'https://picsum.photos/600/600?random=3',
            sizes: ['单人床 90x200cm', '双人床 150x200cm'],
            quantityOptions: ['1套', '2套', '3套'],
            detailDescription: [
              '天然草本精华，温和不刺激。',
              '适合敏感肌肤使用，温和养护。',
              '富含多种植物精华，深层滋养。',
              '长期使用效果显著，让肌肤更加健康。'
            ]
          },
          {
            id: 4,
            name: '植物精油',
            description: '纯植物精油，舒缓放松',
            price: '228',
            priceRange: '¥158.99 - ¥298.00',
            image: require('../assets/特点3.png'),
            detailImage: 'https://picsum.photos/600/600?random=4',
            sizes: ['单人床 90x200cm', '双人床 150x200cm', '大床 180x200cm'],
            quantityOptions: ['1套', '2套', '5套'],
            detailDescription: [
              '纯植物精油，带来舒缓放松的体验。',
              '天然成分，无人工添加剂。',
              '多种香型可选，满足不同喜好。',
              '有助于改善睡眠质量，缓解压力。'
            ]
          }
        ];
        
        this.rawProduct = defaultProducts.find(p => p.id == this.id) || null;
      } finally {
        this.loading = false;
      }
    },
    // 返回上一页
    goBack() {
      this.$router.push('/');
    },
    // 增加数量
    increaseQuantity() {
      this.quantity++;
    },
    // 减少数量
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },
    // 加入购物车
    addToCart() {
      if (!this.selectedSize) {
        alert('请选择床的尺寸！');
        return;
      }
      if (!this.selectedQuantityOption) {
        alert('请选择数量选项！');
        return;
      }
      
      alert(`已成功加入购物车！
商品：${this.product.name}
尺寸：${this.selectedSize}
数量选项：${this.selectedQuantityOption}
数量：${this.quantity}`);
      
      // 可以触发父组件的方法来更新购物车计数
      this.$parent.cartCount = (this.$parent.cartCount || 0) + this.quantity;
    }
  }
}
</script>

<style scoped>
.product-detail-section {
  padding: 40px 0 100px;
  background: white;
  min-height: calc(100vh - 80px);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #666;
  cursor: pointer;
  font-size: 1rem;
  margin-bottom: 40px;
  transition: color 0.3s ease;
  font-weight: 500;
}

.back-button:hover {
  color: #4CAF50;
}

.loading {
  text-align: center;
  padding: 100px 20px;
}

.loading p {
  font-size: 1.2rem;
  color: #666;
}

.product-not-found {
  text-align: center;
  padding: 100px 20px;
}

.product-not-found h2 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 16px;
}

.product-not-found p {
  color: #666;
  margin-bottom: 30px;
  font-size: 1.1rem;
}

.product-detail-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: flex-start;
}

.product-detail-image {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.product-detail-image img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.product-detail-info {
  padding: 20px 0;
}

.product-detail-title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.2;
}

.product-detail-price {
  margin-bottom: 30px;
}

.price-range {
  font-size: 1.5rem;
  font-weight: 600;
  color: #4CAF50;
}

.product-detail-description {
  margin-bottom: 40px;
  line-height: 1.8;
}

.product-detail-description p {
  color: #555;
  margin-bottom: 15px;
  font-size: 1rem;
}

.product-options {
  margin-bottom: 40px;
}

.option-group {
  margin-bottom: 25px;
}

.option-group label {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.option-select {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #E5E5E5;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
  transition: border-color 0.3s ease;
}

.option-select:focus {
  outline: none;
  border-color: #4CAF50;
}

.quantity-group {
  margin-bottom: 25px;
}

.quantity-group label {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 200px;
}

.quantity-controls button {
  width: 40px;
  height: 40px;
  border: 2px solid #E5E5E5;
  background: white;
  border-radius: 6px;
  font-size: 1.2rem;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-controls button:hover {
  border-color: #4CAF50;
  color: #4CAF50;
}

.quantity-controls input {
  width: 80px;
  height: 40px;
  text-align: center;
  border: 2px solid #E5E5E5;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
}

.quantity-controls input:focus {
  outline: none;
  border-color: #4CAF50;
}

.btn {
  display: inline-block;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.btn-primary {
  background: linear-gradient(135deg, #4CAF50, #2E7D32);
  color: white;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #45a049, #1B5E20);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.btn-add-cart {
  width: 100%;
  padding: 16px 24px;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: 50px;
  text-transform: none;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .product-detail-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .product-detail-title {
    font-size: 1.5rem;
  }
  
  .price-range {
    font-size: 1.3rem;
  }
  
  .product-detail-section {
    padding: 20px 0 60px;
  }
  
  .container {
    padding: 0 16px;
  }
  
  .back-button {
    margin-bottom: 20px;
  }
}

@media (max-width: 480px) {
  .product-detail-title {
    font-size: 1.3rem;
  }
  
  .btn-add-cart {
    font-size: 1rem;
    padding: 14px 20px;
  }
  
  .quantity-controls {
    max-width: 100%;
  }
  
  .quantity-controls input {
    flex: 1;
  }
}
</style>